export const TOKEN_STORAGE_KEY = "token";
export const AUTH_LAST_ACTIVITY_KEY = "auth:last-activity-at";
export const AUTH_LOGOUT_BROADCAST_KEY = "auth:logout-broadcast";
export const AUTH_REDIRECT_MESSAGE_KEY = "auth:redirect-message";
export const AUTH_BROADCAST_CHANNEL_NAME = "project-dapur-auth";

export const IDLE_TIMEOUT_MS = 2 * 60 * 60 * 1000;
export const ACTIVITY_WRITE_THROTTLE_MS = 30 * 1000;
export const HEARTBEAT_INTERVAL_MS = 60 * 1000;
export const HEARTBEAT_THROTTLE_MS = 5 * 60 * 1000;

export const SESSION_TIMEOUT_MESSAGE =
  "Sesi berakhir karena tidak ada aktivitas selama lebih dari 2 jam. Silakan login ulang.";
export const SESSION_INVALID_MESSAGE = "Sesi login tidak valid. Silakan login ulang.";

export const getStoredTimestamp = (key) => {
  const rawValue = localStorage.getItem(key);
  const parsedValue = Number(rawValue);
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : 0;
};
